module.exports = __webpack_public_path__ + "img/object@3x.64707714.png";